'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var TableContext = {};

exports.__exports = TableContext;
